/* eslint-disable no-console */
import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import BodyStyles from 'styles/body';
import CommonStyles from 'styles/common';
import FormControlStyles from 'styles/formControl';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { getMsalInstance } from './store/auth/msalConfig';

const updateConfig = (config: Window['AMS_CONFIG']) => {
  const updatedConfig: any = {};
  Object.keys(config).forEach((key) => {
    let value: any = config[key as keyof Window['AMS_CONFIG']];
    if (value === 'true') {
      value = true;
    } else if (value === 'false') {
      value = false;
    }

    updatedConfig[key] = value;
  });

  window.AMS_CONFIG = updatedConfig;
};

updateConfig(window.AMS_CONFIG);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

const msalInstance = getMsalInstance();

const renderApp = (instance: typeof msalInstance) => {
  root.render(
    <React.StrictMode>
      <BodyStyles />
      <CommonStyles />
      <FormControlStyles />
      {instance ? (
        <MsalProvider instance={instance}>
          <App />
        </MsalProvider>
      ) : (
        <App />
      )}
    </React.StrictMode>
  );
};

if (msalInstance) {
  // Show a loading state while MSAL initializes
  root.render(
    <React.StrictMode>
      <BodyStyles />
      <CommonStyles />
      <FormControlStyles />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        Loading...
      </div>
    </React.StrictMode>
  );

  msalInstance
    .initialize()
    .then(async () => {
      const redirectResult = await msalInstance.handleRedirectPromise();
      console.log('[msal] handleRedirectPromise result:', redirectResult);
      console.log('[msal] accounts after init:', msalInstance.getAllAccounts());
      renderApp(msalInstance);
    })
    .catch((error) => {
      console.error('[msal] initialization failed', error);
      renderApp(null);
    });
} else {
  renderApp(null);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

if (window.AMS_CONFIG.APP_ENV !== 'prod') {
  console.log(
    'FieldOps application run with current config: \n',
    window.AMS_CONFIG
  );
}
